<aside id="default-sidebar" class="sidenav" [class.is-collapsed]="collapsed" aria-label="Sidenav">
  <div class="sidenav-inner">
    <div class="sidenav-header">
      <div class="brand-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none">
          <path d="M8.5 3.5h5l4 4V18a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2V5.5a2 2 0 0 1 2-2Z"
            stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
          <path d="M13.5 3.5V8h4" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
          <path d="M8.5 12h7M8.5 15.5h5" stroke="currentColor" stroke-width="1.6"
            stroke-linecap="round" />
        </svg>
      </div>
      <div class="brand-text">
        <div class="brand-title">Solicitudes</div>
        <div class="brand-subtitle">{{ esAdmin ? 'Admin' : 'Usuario' }}</div>
      </div>
    </div>

    <div class="sidenav-section-title">Men&uacute;</div>
    <ul class="sidenav-links">
      <li>
        <a routerLink="/solicitud-listado" [queryParams]="{ estado: 'pendiente' }" (click)="closeMobileSidenav()"
          routerLinkActive="is-active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link">
          <span class="nav-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6"
                d="M4 8h4l2 2h10a2 2 0 0 1 2 2v4.5A2.5 2.5 0 0 1 19.5 19h-13A2.5 2.5 0 0 1 4 16.5V8Z" />
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6"
                d="M4 8V6.5A2.5 2.5 0 0 1 6.5 4h3l2 2" />
            </svg>
          </span>
          <span class="nav-label">Solicitudes abiertas</span>
          <span *ngIf="pendientesCount > 0" class="nav-badge">{{ pendientesCount }}</span>
        </a>
      </li>
      <li>
        <a routerLink="/solicitud-listado" [queryParams]="{ vista: 'historial' }" (click)="closeMobileSidenav()"
          routerLinkActive="is-active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link">
          <span class="nav-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                d="m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z" />
            </svg>
          </span>
          <span class="nav-label">Solicitudes cerradas</span>
        </a>
      </li>
      <li>
        <a routerLink="/solicitud-nueva" (click)="closeMobileSidenav()" routerLinkActive="is-active"
          [routerLinkActiveOptions]="{ exact: true }" class="nav-link">
          <span class="nav-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="8" stroke="currentColor" stroke-width="1.6" />
              <path d="M12 8v8M8 12h8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
            </svg>
          </span>
          <span class="nav-label">Nueva solicitud</span>
        </a>
      </li>
      <li *ngIf="esAdmin">
        <a routerLink="/clientes" (click)="closeMobileSidenav()" routerLinkActive="is-active"
          [routerLinkActiveOptions]="{ exact: true }" class="nav-link">
          <span class="nav-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <circle cx="9" cy="9" r="3" stroke="currentColor" stroke-width="1.6" />
              <circle cx="16.5" cy="10" r="2.5" stroke="currentColor" stroke-width="1.6" />
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6"
                d="M3.5 19v-1a5 5 0 0 1 5-5h2.5" />
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6"
                d="M12.5 19v-0.5a4 4 0 0 1 4-4h1a4 4 0 0 1 4 4v0.5" />
            </svg>
          </span>
          <span class="nav-label">Gestion de usuarios</span>
        </a>
      </li>
    </ul>

    <div class="sidenav-footer">
      <div class="sidenav-footer-logo">
        <img src="assets/logo_healthfinder_XL_BLANCO 2.png" alt="Logo" />
      </div>
      <div class="sidenav-footer-divider" aria-hidden="true"></div>
      <button type="button" (click)="logout()" class="nav-link logout-link">
        <span class="nav-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"
              d="M4.5 6.5A2.5 2.5 0 0 1 7 4h5a2.5 2.5 0 0 1 2.5 2.5V8" />
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"
              d="M14.5 16v1.5A2.5 2.5 0 0 1 12 20H7a2.5 2.5 0 0 1-2.5-2.5v-11" />
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"
              d="M11 12h9m0 0-3-3m3 3-3 3" />
          </svg>
        </span>
        <span class="nav-label">Cerrar sesi&oacute;n</span>
      </button>
    </div>
  </div>
</aside>

<ngx-spinner
  [name]="spinnerName"
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  type="square-jelly-box"
  [fullScreen]="true">
  <p style="color: white"> Cargando... </p>
</ngx-spinner>
